/*
*
* File JS componente Block Text
*
*/

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import blockText from 'components/block-text/block-text';
import blockImage from 'components/block-image/block-image';
import blockGallery from 'components/block-gallery/block-gallery';
import blockEmbed from 'components/block-embed/block-embed';
import blockDownload from 'components/block-download/block-download';


// IMPORT SCSS PER LA COMPILAZIONE
//--------------------------------------------------------------------//

import './blocks-basic-page.scss';

//--------------------------------------------------------------------//


// EXPORT COMPONENTE
//--------------------------------------------------------------------//

const blocksBasicPage = () =>
{
    blockGallery();
}

export default blocksBasicPage;

//--------------------------------------------------------------------//